// extracted by mini-css-extract-plugin
export default {"nav":"kT0Ql","menuButton":"I0naS","burgerButton":"EnFvW","focus-visible":"k8yXo","menuIcon":"TjLnz","opened":"mVdUV","menuIconItem":"mnjR6","linkWrapper":"aM3X8","link":"pkDDW"};